import { render, staticRenderFns } from "./RequestStatusBadge.vue?vue&type=template&id=066863cc"
import script from "./RequestStatusBadge.vue?vue&type=script&lang=js"
export * from "./RequestStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports